import React from 'react';
import { twMerge } from 'tailwind-merge';

import Duration from '../../../../../common/components/Duration';

export interface VideoCardTitleProps {
  duration: number;
  title: string;
  shouldInvertControlsVisibility: boolean;
  isHovering: boolean;
}

export const VideoCardTitle = ({
  duration,
  title,
  shouldInvertControlsVisibility,
  isHovering,
}: VideoCardTitleProps) => {
  const hoverStyle = shouldInvertControlsVisibility
    ? 'opacity-0'
    : 'opacity-100';
  const nonHoverStyle = shouldInvertControlsVisibility
    ? 'opacity-100'
    : 'opacity-0';

  return (
    <div
      data-testid="video-card-title"
      className={twMerge(
        `stock-item-title flex space-x-2 items-center absolute top-0 left-0 px-4 pt-4 w-full pointer-events-none`,
        isHovering ? hoverStyle : nonHoverStyle
      )}
    >
      <div
        className={
          'py-0.5 px-1.5 bg-white rounded text-sm leading-5 text-gray-900'
        }
      >
        <Duration seconds={duration} />
      </div>
      <h3 className="truncate font-semibold text-white m-0 text-base leading-5">
        {title}
      </h3>
    </div>
  );
};
